<template>
  <div class="container-fluid">
    <PainelAcesso>
      <template #cabecalho >
        <div class="modal-title text-center">
          <div class="d-flex justify-content-start">
            <h4 class="textos text-left text-gray w-75 mx-auto my-auto">
              <p v-if="temVencimentoReferenteContratoPrincipal">Fatura Pendente</p>
              <p v-else>Pedido Pendente</p>
            </h4>
          </div>
        </div>
      </template>
      <template #corpo>
        <form class="mt-2">
          <div class="d-flex justify-content-center w-75 mx-auto my-auto">
            <p v-if="temVencimentoReferenteContratoPrincipal">Olá! Notamos que há uma fatura pendente de pagamento em sua conta.
              Que tal resolver agora e garantir acesso contínuo a todas as funcionalidades do MIRT?
              Clique aqui e vamos juntos desbloquear o pleno potencial para seu escritório.
              <strong>{{obterMensagemBloqueio}}</strong>
            </p>
            <p v-else>
              Olá! Vimos que você começou a adicionar serviços adicionais ao seu plano MIRT mas não finalizou.
              Que tal completar esse passo agora e desbloquear todo o potencial para o seu escritório?
            </p>
          </div>
          <div class="d-flex justify-content-center">
            <div class="d-flex" v-if="temPagamentoPendente">
              <b-button variant="btn btn-verde col-auto" :disabled="flagsDeControle.manipulandoDados.status" @click="confirmarNotificacao(null, false)">Ok</b-button>
            </div>
            <div class="d-flex" v-else-if="temVencimentoReferenteContratoPrincipal">
              <b-button
                variant="btn btn-verde col-auto"
                v-if="representanteLegal"
                :disabled="flagsDeControle.manipulandoDados.status" @click="resolverPendenciaFatura()">
                Resolver Pendência
              </b-button>
              <div class="ml-1"></div>
              <b-button variant="btn btn-cinza col-auto" :disabled="flagsDeControle.manipulandoDados.status" @click="confirmarNotificacao()">Mais tarde</b-button>
            </div>
            <div class="d-flex" v-else>
              <b-button v-if="representanteLegal" variant="btn btn-verde col-auto" :disabled="flagsDeControle.manipulandoDados.status" @click="resolverPendenciaFatura()">Sim</b-button>
              <div class="ml-1"></div>
              <b-button variant="btn btn-cinza col-auto" :disabled="flagsDeControle.manipulandoDados.status" @click="confirmarNotificacao()">Não, Obrigado</b-button>
            </div>
          </div>
          <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex justify-content-center align-items-center">
            <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
        </form>
      </template>
    </PainelAcesso>
  </div>
</template>

<script>
import AlertaVencimento from './js/alertaVencimento'
export default AlertaVencimento
</script>
